<button mat-icon-button class="close-button" (click)="close()">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<h1 *ngIf="layoutConf.isMobile" matDialogTitle class="smaller-font" style="font-size: 12px;">{{data.title}}</h1>
<h1 *ngIf="!layoutConf.isMobile" matDialogTitle class="smaller-font">{{data.title}}</h1>
<div mat-dialog-content>
  <mat-card class="p-0">
    <form [formGroup]="itemForm" (ngSubmit)="submit()" (keydown.enter)="handleFormEnter($event)">
      <div fxLayout="row wrap" fxLayout.lt-sm="column">
        <div fxFlex="100" class="pr-1"><br></div>
        <mat-tab-group>
          <mat-tab label="Datalhe">
            <div fxLayout="row wrap" fxLayout.lt-sm="column">
              <div fxFlex="100" class="pr-1"><br></div>
              <div fxFlex="40" class="pr-1 ml-1">
                <mat-form-field class="full-width">
                  <input matInput id="qtde" type="text" name="qtde" step="any" (focus)="armMobileReplace($event)" (blur)="disarmMobileReplace($event); changeQtdeOrValorUnitario(itemForm)"
                    (keydown)="applyMobileReplaceOnFirstKey($event, 'qtde')"
                    [formControl]="itemForm.controls['qtde']" placeholder="Qtde"
                    currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }">

                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayout.lt-sm="column">
              <div fxFlex="40" class="pr-1 ml-1">
                <mat-form-field class="full-width">
                  <input matInput id="valorUnitario" type="text" name="valorUnitario" step="any"
                    (focus)="armMobileReplace($event)" (blur)="disarmMobileReplace($event); changeQtdeOrValorUnitario(itemForm)" (keydown)="applyMobileReplaceOnFirstKey($event, 'valorUnitario')" appOnReturn 
                    [formControl]="itemForm?.controls['valorUnitario']!" placeholder="Valor Unitário"
                     currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                </mat-form-field>
              </div>
              <div fxFlex="29" class="pr-1 ml-1">
                <mat-form-field class="full-width">
                  <input matInput id="descValorUnitario" type="text" name="descValorUnitario" step="any"
                    (focus)="$event.target.select()" appOnReturn 
                    [formControl]="itemForm?.controls['descValorUnitario']!" placeholder="Desconto"  (blur)="changeDescValorUnitario(itemForm)"
                       currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                </mat-form-field>
              </div>
              <div fxFlex="19" class="pr-1 ml-1">
                <mat-form-field class="full-width">
                  <input matInput id="descPercUnitario" type="text" name="descPercUnitario" step="any"
                    (focus)="$event.target.select()" appOnReturn 
                    [formControl]="itemForm?.controls['descPercUnitario']!" placeholder="(%) Desconto"  (blur)="changeDescPercUnitario(itemForm)"
                       currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }">
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayout.lt-sm="column"></div>
            <div fxLayout="row wrap" fxLayout.lt-sm="column">
              <div fxFlex="40" class="pr-1 ml-1">
                <mat-form-field class="full-width">
                  <input matInput id="valorUnitarioLiquido" type="text" name="valorUnitarioLiquido" step="any"
                     (focus)="$event.target.select()" [formControl]="itemForm?.controls['valorUnitarioLiquido']"
                    placeholder="Valor Unitário Líquido" readonly
                    currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayout.lt-sm="column">
              <div fxFlex="40" class="pr-1 ml-1">
                <mat-form-field class="full-width">
                  <input matInput id="valorTotal" type="text" name="valorTotal" step="any"
                    (focus)="armMobileReplace($event)" (blur)="disarmMobileReplace($event); changeValorTotal(itemForm)" (keydown)="applyMobileReplaceOnFirstKey($event, 'valorTotal')" appOnReturn 
                    [formControl]="itemForm?.controls['valorTotal']!" placeholder="Valor Total"
                    currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayout.lt-sm="column">
              <div fxFlex="40" class="pr-1 ml-1">
                <mat-form-field class="full-width">
                  <input matInput id="valorTotalLiquido" type="text" name="valorTotalLiquido" step="any"
                    (focus)="$event.target.select()" appOnReturn 
                    [formControl]="itemForm?.controls['valorTotalLiquido']!" placeholder="Valor Total Líquido" readonly
                    currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                </mat-form-field>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="Impostos (Digitação Manual)">
            <mat-tab-group>
              <mat-tab label="ICMS">
                <div fxLayout="row wrap" fxLayout.lt-sm="column">
                  <div fxFlex="100" class="pr-1"><br></div>
                  <div fxFlex="50" class="pr-1">
                    <div fxFlex="50" class="pr-1 ml-1">
                      <mat-checkbox name="fixarIcms" [formControl]="itemForm.controls['icmsDigitacaomanual']">Fixar ICMS?
                      </mat-checkbox>
                    </div>
                  </div>
                </div>
                <div fxLayout="row wrap" fxLayout.lt-sm="column">
                  <div fxFlex="100" class="pr-1"><br></div>
                  <div fxFlex="40" class="pr-1 ml-1">
                    <mat-form-field class="full-width">
                      <input matInput id="icmsBasecalculo" type="text" name="icmsBasecalculo" step="any"
                        (focus)="$event.target.select()" appOnReturn [formControl]="itemForm?.controls['icmsBasecalculo']!"
                        placeholder="Base de Cálculo"currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }" [readonly]="!itemForm.controls['icmsDigitacaomanual'].value">
                    </mat-form-field>
                  </div>
                  <div fxFlex="40" class="pr-1 ml-1">
                    <mat-form-field class="full-width">
                      <input matInput id="icmsSubstBasecalculo" type="text" name="icmsSubstBasecalculo" step="any"
                        (focus)="$event.target.select()" appOnReturn [formControl]="itemForm?.controls['icmsSubstBasecalculo']!"
                        placeholder="Base de Cálculo S.T."currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }" [readonly]="!itemForm.controls['icmsDigitacaomanual'].value">
                    </mat-form-field>
                  </div>
                </div>
                <div fxLayout="row wrap" fxLayout.lt-sm="column">
                  <div fxFlex="40" class="pr-1 ml-1">
                    <mat-form-field class="full-width">
                      <input matInput id="icmsPerc" type="text" name="icmsPerc" step="any"
                        (focus)="$event.target.select()" appOnReturn [formControl]="itemForm?.controls['icmsPerc']!"
                        placeholder="(%)Alíquota"currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }" [readonly]="!itemForm.controls['icmsDigitacaomanual'].value">
                    </mat-form-field>
                  </div>
                  <div fxFlex="40" class="pr-1 ml-1">
                    <mat-form-field class="full-width">
                      <input matInput id="icmsSubstPerc" type="text" name="icmsSubstPerc" step="any"
                        (focus)="$event.target.select()" appOnReturn [formControl]="itemForm?.controls['icmsSubstPerc']!"
                        placeholder="(%)Alíquota S.T."currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }" [readonly]="!itemForm.controls['icmsDigitacaomanual'].value">
                    </mat-form-field>
                  </div>
                </div>
                <div fxLayout="row wrap" fxLayout.lt-sm="column">
                  <div fxFlex="40" class="pr-1 ml-1">
                    <mat-form-field class="full-width">
                      <input matInput id="icmsValor" type="text" name="icmsValor" step="any"
                        (focus)="$event.target.select()" appOnReturn [formControl]="itemForm?.controls['icmsValor']!"
                        placeholder="Valor"currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }" [readonly]="!itemForm.controls['icmsDigitacaomanual'].value">
                    </mat-form-field>
                  </div>
                  <div fxFlex="40" class="pr-1 ml-1">
                    <mat-form-field class="full-width">
                      <input matInput id="icmsSubstValor" type="text" name="icmsSubstValor" step="any"
                        (focus)="$event.target.select()" appOnReturn [formControl]="itemForm?.controls['icmsSubstValor']!"
                        placeholder="Valor S.T."currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }" [readonly]="!itemForm.controls['icmsDigitacaomanual'].value">
                    </mat-form-field>
                  </div>
                </div>

              </mat-tab>
              <mat-tab label="IPI">
                <div fxLayout="row wrap" fxLayout.lt-sm="column">
                  <div fxFlex="100" class="pr-1"><br></div>
                  <div fxFlex="50" class="pr-1">
                    <div fxFlex="50" class="pr-1 ml-1">
                      <mat-checkbox name="fixarIPI" [formControl]="itemForm.controls['ipiDigitacaomanual']">Fixar IPI?
                      </mat-checkbox>
                    </div>
                  </div>
                </div>
                <div fxLayout="row wrap" fxLayout.lt-sm="column">
                  <div fxFlex="100" class="pr-1"><br></div>
                  <div fxFlex="50" class="pr-1 ml-1">
                    <mat-form-field class="full-width">
                      <input matInput id="ipiPercentual" type="text" name="ipiPercentual" step="any"
                        (focus)="$event.target.select()" appOnReturn [formControl]="itemForm?.controls['ipiPercentual']!"
                        placeholder="(%)Alíquota"currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }" [readonly]="!itemForm.controls['ipiDigitacaomanual'].value">
                    </mat-form-field>
                  </div>
                  <div fxFlex="100" class="pr-1"><br></div>
                  <div fxFlex="50" class="pr-1 ml-1">
                    <mat-form-field class="full-width">
                      <input matInput id="ipiValor" type="text" name="ipiValor" step="any"
                        (focus)="$event.target.select()" appOnReturn [formControl]="itemForm?.controls['ipiValor']!"
                        placeholder="Valor"currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }" [readonly]="!itemForm.controls['ipiDigitacaomanual'].value">
                    </mat-form-field>
                  </div>
                </div>
              </mat-tab>
              <mat-tab label="FUNRURAL">
                <div fxLayout="row wrap" fxLayout.lt-sm="column">
                  <div fxFlex="100" class="pr-1"><br></div>
                  <div fxFlex="50" class="pr-1">
                    <div fxFlex="50" class="pr-1 ml-1">
                      <mat-checkbox name="fixarFUNRURAL" [formControl]="itemForm.controls['funruralDigitacaomanual']">Fixar FUNRURAL?
                      </mat-checkbox>
                    </div>
                  </div>
                </div>
                <div fxLayout="row wrap" fxLayout.lt-sm="column">
                  <div fxFlex="100" class="pr-1"><br></div>
                  <div fxFlex="40" class="pr-1 ml-1">
                    <mat-form-field class="full-width">
                      <input matInput id="funruralBasecalculo" type="text" name="funruralBasecalculo" step="any"
                        (focus)="$event.target.select()" appOnReturn [formControl]="itemForm?.controls['funruralBasecalculo']!"
                        placeholder="Base de Cálculo"currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }" readonly>
                    </mat-form-field>
                  </div>
                </div>
                <div fxLayout="row wrap" fxLayout.lt-sm="column">
                  <div fxFlex="40" class="pr-1 ml-1">
                    <mat-form-field class="full-width">
                      <input matInput id="funruralValor" type="text" name="funruralPerc" step="any" (focus)="$event.target.select()"
                        appOnReturn [formControl]="itemForm?.controls['funruralPerc']!" placeholder="(%) Alíquota" currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }" readonly>
                    </mat-form-field>
                  </div>
                </div>
                <div fxLayout="row wrap" fxLayout.lt-sm="column">
                  <div fxFlex="40" class="pr-1 ml-1">
                    <mat-form-field class="full-width">
                      <input matInput id="funruralValor" type="text" name="funruralValor" step="any"
                        (focus)="$event.target.select()" appOnReturn [formControl]="itemForm?.controls['funruralValor']!"
                        placeholder="Valor" currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }" readonly>
                    </mat-form-field>
                  </div>
                </div>
              </mat-tab>
              <mat-tab label="BENEFÍCIO FISCAL">
                <div fxLayout="row wrap" fxLayout.lt-sm="column">
                  <div fxFlex="50" class="pr-1 ml-1">
                    <mat-form-field style="min-width:350px;">
                      <mat-label>Tipo de Benefício Fiscal </mat-label>
                      <mat-select [formControl]="itemForm?.controls['beneficioFiscal']!">
                        <mat-option *ngFor="let item of this.enums?.tipoBeneficioFiscal" [value]="item?.codigo">
                          {{item?.descricao}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div fxLayout="row wrap" fxLayout.lt-sm="column">
                  <div fxFlex="50" class="pr-1 ml-1">
                    <mat-form-field class="full-width" style="min-width:350px;">
                      <input [imask]="maskUpper" matInput name="codigoBeneficioFiscalUF" matInput
                          type="text" [formControl]="itemForm?.controls['codigoBeneficioFiscalUF']!"
                          placeholder="Código Benefício Fiscal">
                  </mat-form-field>
                  </div>
                </div>
              </mat-tab>  
              <mat-tab label="IMPOSTO DE IMPORTAÇÃO">
                <div fxLayout="row wrap" fxLayout.lt-sm="column">
                  <div fxFlex="100" class="pr-1"><br></div>
                  <div fxFlex="50" class="pr-1">
                    <div fxFlex="50" class="pr-1 ml-1">
                      <mat-checkbox name="fixarII" [formControl]="itemForm.controls['informaImpostoImportacao']">Fixar Imposto de Importação?
                      </mat-checkbox>
                    </div>
                  </div>
                </div>
                <div fxLayout="row wrap" fxLayout.lt-sm="column">
                  <div fxFlex="100" class="pr-1"><br></div>
                  <div fxFlex="40" class="pr-1 ml-1">
                    <mat-form-field class="full-width">
                      <input matInput id="importacaoValorBaseCalculo" type="text" name="importacaoValorBaseCalculo" step="any"
                        (focus)="$event.target.select()" appOnReturn [formControl]="itemForm?.controls['importacaoValorBaseCalculo']!"
                        placeholder="Base de Cálculo"currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }" [readonly]="!itemForm.controls['informaImpostoImportacao'].value">
                    </mat-form-field>
                  </div>
                </div>
                <div fxLayout="row wrap" fxLayout.lt-sm="column">
                  <div fxFlex="40" class="pr-1 ml-1">
                    <mat-form-field class="full-width">
                      <input matInput id="importacaoValorImpostoImportacao" type="text" name="importacaoValorImpostoImportacao" step="any" (focus)="$event.target.select()"
                        appOnReturn [formControl]="itemForm?.controls['importacaoValorImpostoImportacao']!" placeholder="Valor do Imposto" currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }" [readonly]="!itemForm.controls['informaImpostoImportacao'].value">
                    </mat-form-field>
                  </div>
                </div>
                <div fxLayout="row wrap" fxLayout.lt-sm="column">
                  <div fxFlex="40" class="pr-1 ml-1">
                    <mat-form-field class="full-width">
                      <input matInput id="importacaoValorDespesaAduaneira" type="text" name="importacaoValorDespesaAduaneira" step="any"
                        (focus)="$event.target.select()" appOnReturn [formControl]="itemForm?.controls['importacaoValorDespesaAduaneira']!"
                        placeholder="Valor Despesas Aduaneiras" currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }" [readonly]="!itemForm.controls['informaImpostoImportacao'].value">
                    </mat-form-field>
                  </div>
                </div>
                <div fxLayout="row wrap" fxLayout.lt-sm="column">
                  <div fxFlex="40" class="pr-1 ml-1">
                    <mat-form-field class="full-width">
                      <input matInput id="importacaoValorIOF" type="text" name="importacaoValorIOF" step="any"
                        (focus)="$event.target.select()" appOnReturn [formControl]="itemForm?.controls['importacaoValorIOF']!"
                        placeholder="Valor IOF" currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }" [readonly]="!itemForm.controls['informaImpostoImportacao'].value">
                    </mat-form-field>
                  </div>
                </div>
              </mat-tab>

              
            </mat-tab-group>
          </mat-tab>
          <mat-tab label="Dados Adicionais">
            <div fxLayout="row wrap" fxLayout.lt-sm="column">
              <div fxFlex="100" class="pr-1 ml-1">
                <mat-form-field class="full-width">
                  <textarea
                    matInput
                    class="dados-adicionais-textarea"
                    id="infAdProd"
                    name="infAdProd"
                    [formControl]="itemForm?.controls['infAdProd']"
                    placeholder="Informações adicionais do Produto"
                    rows="10">
                  </textarea>
                </mat-form-field>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </form>
    <mat-dialog-actions>
      <div fxFlex="100" class="mt-1 dialog-actions">
          <button class="mb-8" mat-raised-button [matTooltip]="'Salvar Lançamento'" color="primary"
              (click)="submit();$event.preventDefault();">
              <mat-icon>save</mat-icon>
              <ng-container *ngIf="!layoutConf.isMobile"> {{"SAVE" | translate }} </ng-container>
          </button>
          <span fxFlex></span>
          <button mat-button color="warn" type="button" (click)="close()">
              <mat-icon>close</mat-icon>{{"CLOSE" | translate }}
              
          </button>
      </div>
    </mat-dialog-actions>
  </mat-card>
</div>
